<template>
    <div id="studentLogin">
      <div class="header">
        <!-- <img src="@/assets/background/homeBG.png" /> -->
        <div class="title">龙猫校园游客绑定</div>
      </div>
      <div class="contain">
          <form class="login-form">
             <!-- <div class="login-form-list">
                  <label class="login-form-lable">学&nbsp;&nbsp;&nbsp;&nbsp;校</label>
                <input type="text" placeholder="请选择学校" autoComplete="true" v-model="schoolName" readonly  @click="schoolshowPicker = true">
                <van-popup v-model="schoolshowPicker" round position="bottom" :style="{ height: '55%' }">
                    <van-search v-model="searchvalue" placeholder="请输入搜索关键词进行检索" />
                    <van-picker
                    :columns="columns"
                    show-toolbar
                    @cancel="schoolshowPicker = false"
                    @confirm="onConfirm"
                    />
                </van-popup>
              </div> -->
              <div class="login-form-list">
                  <label class="login-form-lable">昵&nbsp;&nbsp;&nbsp;&nbsp;称</label><input type="text" placeholder="请输入昵称" autoComplete="true" v-model="userName">
              </div>
               <div class="login-form-list">
                  <label class="login-form-lable">手&nbsp;机&nbsp;号</label><input type="text" placeholder="请输入手机号" autoComplete="true" v-model="phnoeNum">
              </div>
           <div class="login-form-list">
                  <label class="login-form-lable">性&nbsp;&nbsp;&nbsp;&nbsp;别</label>
                  <div style="width: 70%;">
                    <van-radio-group v-model="sex" direction="horizontal" size="small">
                    <van-radio name="男">男</van-radio>
                    <van-radio name="女">女</van-radio>
                   </van-radio-group>
                  </div>
                  <!-- <input type="text" placeholder="请输入昵称" autoComplete="true" v-model="sex"> -->
              </div>
                  <!-- <van-field  v-model="age" type="number" label="年龄" placeholder="请输入测试人员年龄"/> -->
        
               <div class="login-form-list">
                  <label class="login-form-lable">年&nbsp;龄&nbsp;&nbsp;</label>
                  <el-input-number style="width: 100%;" size="mini" v-model="age" controls-position="right"  :min="4" :max="70" precision="0"></el-input-number>
                  <!-- <input type="number"  placeholder="请输入测试人员年龄" autoComplete="true" value="age" v-model="age"> -->
              </div>
            
           
             
              <!-- <div class="login-form-list">
                  <label class="login-form-lable">密&nbsp;&nbsp;&nbsp;&nbsp;码</label><input type="password" placeholder="请输入密码" autoComplete="true" v-model="passWord">
              </div> -->
              <button type="button" class="login-form-btn" @click="getLogin">绑&nbsp;&nbsp;定</button>
          </form>
      </div>
      <div id="container" style="display: none"></div>
    </div>
  </template>
  
  <script>
//   import { Login, getSchoolList, getOneSchool } from '../services/studentLogin'
//   import AMapLoader from '@amap/amap-jsapi-loader'
import { selectScoreByPhoneNumber} from "@/api/whitePage/teacherScore.js";
  
  import { Notify } from 'vant'
  const authCookieName = 'Authorization' // cookie缓存名称
  export default {
    name: 'studentLogin',
    data () {
      return {
        userName: '',
        passWord: '',
        schoolName: '',
        schoolId: '',
        searchvalue: '',
        snCode: '',
        phnoeNum: '',
        age:"",
        sex:"男",
        schoolshowPicker: false,
        columnsAll: [],
        columns: [],
        lat: '',
        lon: '',
        address: '',
        loading: false,
        isLocation: false
  
      }
    },
    created () {
        let data = JSON.parse(localStorage.getItem('/whitePage/TouristBind/infoData'))||{}
        this.phnoeNum = data.phnoeNum||''
        this.userName = data.userName||''
        this.age = data.age||''
    },
    watch: {
      searchvalue (val) {
        console.log(val)
        const search = val
        this.columns = this.columnsAll.filter(function (product) {
          console.log('过滤', product)
          const searchField = { text: product.text, value: product.value }
          return Object.keys(searchField).some(function (key) {
            console.log('key值', key)
            return String(product[key]).toLowerCase().indexOf(search) > -1
          })
        })
      }
    },
    methods: {
  
      onError (obj) {
        alert(obj.info + '--' + obj.message)
        console.log(obj)
      },
  
      getOneSchool () {
        console.log(this.lat)
        getOneSchool({ latitude: this.lat, longitude: this.lng }).then(dl => {
          console.log(dl.body)
          if (dl.body.length > 0) {
            this.schoolName = dl.body[0].schName
            this.schoolId = dl.body[0].schCode
          }
        })
      },
  
      getSchoolList () {
        getSchoolList().then(res => {
          this.columnsAll = res.body.map(item => {
            return { text: item.name, value: item.code }
          })
          this.columns = res.body.map(item => {
            return { text: item.name, value: item.code }
          })
          // this.init()
        })
      },
      onConfirm (val) {
        console.log(val)
        this.schoolName = val.text
        this.schoolId = val.value
        this.schoolshowPicker = false
      },
      getLogin () {

        // localStorage.setItem('Authorization', 'IOT6kIJHTCXQSTovookcGUADl5ySQqnGFKcr8BHdb4nGBcLQZIoNMqFvg==')
        // sessionStorage.setItem('studentTitleCard', '{"id":"stu-2024040900000000002","snCode":"18226351321","studentName":"杨森","schoolCode":"LMWZ","schoolName":"龙猫小学","status":"1","content":null,"adminClassId":"class-20231011000012","adminClassName":" 凤凰研究院班 ","studentGrade":"16","studentGradeName":"小学六年级 ","birthDay":"1997-06-01","sex":null,"text":"杨森"}')
        // localStorage.setItem('userInfo', '{"id":"stu-2024040900000000002","snCode":"18226351321","studentName":"杨森","schoolCode":"LMWZ","schoolName":"龙猫小学","status":"1","content":null,"adminClassId":"class-20231011000012","adminClassName":" 凤凰研究院班 ","studentGrade":"16","studentGradeName":"小学六年级 ","birthDay":"1997-06-01","sex":null,"text":"杨森"}')
        // localStorage.setItem('openId', '{"":"龙猫小":"杨森"}')
         if (this.phnoeNum === '') {
          Notify({ type: 'warning', message: '请输入手机号' })
          return
        }
         if (this.age === '') {
          Notify({ type: 'warning', message: '请输入年龄' })
          return
        }
        localStorage.setItem('/whitePage/TouristBind/infoData', JSON.stringify({
            phnoeNum:this.phnoeNum,
            userName:this.userName,
            age:this.age
        }))
        
        // /web/admin/deviceInfo/selectScoreByPhoneNumber
        // this.$router.push(
        //    '/parentHomePage'
        //   )
          console.log(1111);
          let openId = ""
          let schoolCode = this.$route.query.schoolCode
          let snCode = this.$route.query.snCode
          openId = localStorage.getItem('openId')

            this.$dialog
            .alert({
            message: '是否确认绑定?',
            showCancelButton: true
            })
            .then(() => {
                       selectScoreByPhoneNumber({
                        schoolCode: schoolCode,
                        snCode: snCode,
                        openId: openId,
                        studentName: this.userName,
                        phoneNumber: this.phnoeNum,
                        sex: this.sex,
                        age: this.age,
                    }).then(res=>{
                    this.$router.push(
                            '/parentHomePage'
                            )
                    })
            })
            .catch(() => {
            // on cancel
            })
       
          
return
        if (this.schoolId === '') {
          Notify({ type: 'warning', message: '请选择学校' })
          return
        }
        if (this.snCode === '') {
          Notify({ type: 'warning', message: '请输入学号' })
          return
        }
        if (this.userName === '') {
          Notify({ type: 'warning', message: '请输入姓名' })
          return
        }
        
        
        // if (this.passWord === '') {
        //   Notify({ type: 'warning', message: '请输入密码' })
        //   return
        // }
        Login({
          studentName: this.userName,
          passWord: this.passWord,
          schoolId: this.schoolId,
          snCode: this.snCode,
          phnoeNum: this.phnoeNum,
          testId:this.$route.query.testId
        }).then((data) => {
          this.$set(data.obj, 'idNumType', data.idNumType)
          this.$set(data.obj, 'type', data.type)
          this.$set(data.obj, 'token', data.token)
          this.$set(data.obj, 'humanType', data.humanType)
          this.$set(data.obj, 'instructions', data.instructions||'')
          
          sessionStorage.setItem('userInfo', JSON.stringify(data.obj))
          sessionStorage.setItem(authCookieName, data.token)
          this.$router.push({
            path: '/myFitness'
          })
        })
        // this.$router.push({
        //     path: '/myFitness'
        // })
      }
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  #studentLogin {
    //   background: #ffffff;
      background-image: url('../../../assets/background/homeBG.png');
	  background-repeat: no-repeat;
	background-size: cover;
    //   @/assets/background/homeBG.png
      width: 100%;
      height: 100vh;
      font-size: 16px;
  
      .header {
          padding: 15% 0 20%;
          text-align: center;
          width: 100%;
          color: #000000;
  
          img {
              width: 25%;
              height: auto;
          }
          .title{
              font-size: 24px;
              line-height: 50px;
          }
      }
      .contain {
          padding: 0 15%;
          width: 100%;
          box-sizing: border-box;
  
          .login-form-list{
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
              padding: 15px 20px;
              border: 1px solid #d2d2d2;
              color: #727272;
              border-radius: 30px;
             .login-form-lable{
                color: #817e7e;
             }
             ::v-deep .el-input__inner {
              border: 1px solid #fff;
              text-align: left;
             }
              input{
                  width: 70%;
                  border: none;
                  box-sizing: border-box;
                  color: #000;
              }
          }
          button{
              margin-top: 10%;
              width: 100%;
              height: 50px;
              border: none;
              background: #3460e7;
              border-radius: 25px;
              color: #ffffff;
          }
      }
  }
  </style>
  